
<template>
  <div>
      <div v-show="showVue" style="width:1300px;margin:0 auto;margin-top:50px;">       
              <!-- 表单内容 -->
         <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">   
             <p class="mt-2 mb-2 font">
                <img src="../../static/images/kucun.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/>
                <span class="p-1" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                   开票信息
                </span>
             
                <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;margin-right:6px;" @click="$router.go(-1)">
                           &times;
                </span>
              </p>
              
                 

            <table v-if="showPage" class="table table-striped table-hover" ref="print">
                    <thead>
                      <tr style="white-space: nowrap;" class="text-center">
                        <th>厂家</th>
                        <th>公司名称</th>
                        <th>税号</th>
                        <th>地址电话</th>
                        <th>开户行与账户</th>
                        <th>开票金额</th>
                        <th>出票时间</th>
                        <th>是否出票</th>
                        <th style="width:150px;">操作</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in tableData" :key="index" class="text-center">
                              <td class="jz_middle">{{item.cjmc}}</td>
                              <td v-if="item.gsmc!=null" class="jz_middle">{{item.gsmc}}</td>
                              <td v-if="item.gsmc==null" class="jz_middle">
                                  <input type="text" v-model="item.Gsmc">
                              </td>
                              <td v-if="item.sh!=null" class="jz_middle">{{item.sh}}</td>
                              <td v-if="item.sh==null" class="jz_middle">
                                  <input type="text" style="width:80px;" v-model="item.Sh">
                              </td>
                              <td v-if="item.dzdh!=null" class="jz_middle">{{item.dzdh}}</td>
                              <td v-if="item.dzdh==null" class="jz_middle">
                                   <input type="text" style="width:200px;" v-model="item.Dzdh">
                              </td>
                              <td v-if="item.khhzh!=null" class="jz_middle">{{item.khhzh}}</td>
                              <td v-if="item.khhzh==null" class="jz_middle">
                                   <input type="text" v-model="item.Khhzh">
                              </td>
                              <td class="jz_middle" style="color:red;">{{item.kpje}}</td>
                              <td class="jz_middle">{{item.cpsj}}</td>
                              <td class="jz_middle">{{item.iscp | iscp}}</td>
                              <td class="jz_middle">
                                  <button v-show="item.iscp==0" class="bg-primary button_zi heit" @click="SubmitInformation(index,item.id,item.gsmc,item.sh,item.dzdh,item.khhzh)">
                                       提交信息
                                  </button>
                              </td>
                      </tr>
                    </tbody>
                  </table>

                  <div v-else>

                       <img src="../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">

                  </div>


                <p class="text-center">
                    <img src="../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
                </p>
            

       </div> 
      </div>

    <!-- 详情内容 -->
                   

                <div>
                  <transition name='fade'>
                           <loading v-show="isLoading">
                                                
                           </loading>
                  </transition>
                </div>
     </div>
</template>
<script>
import vPagination from "../components/Pagination.vue"
import Loading from '../components/Loading.vue'
import { async } from 'q';
export default {
      name: 'SaleQuery',
    data () {
      return {
       
        isLoading: false,
        tableData: [],
        Record:'',//总记录数
        Pcount:'',//总页数
        PageNo:1, //当前页码
        showPage:true,
        details:[],
        totalLimitMoney:'',

           total:1,     // 记录总条数
            display: 20,   // 每页显示条数
            current: 1,   // 当前的页数
      //  search:{
      //    gsmc:"",
      //     sh:"",
      //     dzdh:"",
      //     khhzh:"",
      //  },
          currentGsmc:"",
          currentSh:"",
          currentDzdh:"",
          currentKhhzh:"",
          showVue:false,

      }
    },
    components:{
        vPagination,
        Loading
    },
    computed:{
         
},
filters: {
  //过滤器时间转换
  //时间转换
      formatUTC:function(utc_datetime) {
          return utc_datetime.replace(/T/ig,"  ").substring(0,20)
        } ,
     
        state:function(state){
            if(state==2)
            {
              return "限制结算50万"
            }
            else{
               return ""
            }
        },
        status:function(status){
          if(status==-1){
            return "删除"
          }
          else
          {
            return ""
          }
        },
        iscp:function(iscp){
           if(iscp==0)
            {
               return "未出票"
            }
            else if(iscp==1)
            {
               return "已出票"
            }
        }
},

methods: {


      searchEnterFun(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.Search();
         }
      },
      

  
      getClerkStoreGoodsQuery: async function (PageIndex) {
          // this.isLoading=true;
         await this.$http.post('Dls/GetKp', {
           lx:1
        }).then(res=>{
            // console.log(res)
                    const obj=res.data
                    this.showVue=true;
                    // console.log(obj)
                    if(res.data.isok)
                    {
                        
                        this.tableData = obj.data
                        if(this.tableData.length>0)
                        {
                            this.showPage=true;
                        }
                        else{
                            this.showPage =false;
                        }
                     
                    }
                    else{

                        alert(res.data.data.message)
                    }
               

        })
         
         
      },

       getCurrentInformation(index,gsmc,sh,dzdh,khhzh){
             if(gsmc==null)
             {
               this.currentGsmc=this.tableData[index].Gsmc;               
             }
             else{
               this.currentGsmc=gsmc
             }
             if(sh==null)
             {
               this.currentSh=this.tableData[index].Sh;
             }
             else{
               this.currentSh=sh;
             }
             if(dzdh==null)
             {
               this.currentDzdh=this.tableData[index].Dzdh;
             }
             else{
               this.currentDzdh=dzdh;
             }
             if(khhzh==null)
             {
               this.currentKhhzh=this.tableData[index].Khhzh;
             }
             else{
               this.currentKhhzh=khhzh;
             }
         
       },

      //提交信息
      SubmitInformation:async function(index,id,gsmc,sh,dzdh,khhzh){
          this.getCurrentInformation(index,gsmc,sh,dzdh,khhzh)
           await this.$http.post('Dls/GetKp', {
           lx:2,
           gsmc:this.currentGsmc,
           sh:this.currentSh,
           dzdh:this.currentDzdh,
           khhzh:this.currentKhhzh,
           id:id,
        }).then(res=>{
            // console.log(res)
            if(res.data.isok)
            {
               alert(res.data.message)
               this.getClerkStoreGoodsQuery();
            } 
            else{
              alert(res.data.message)
            }
        })
              
      }
  
    },
     mounted(){
    },
     created () {

        this.getClerkStoreGoodsQuery();
        
    }
}
</script>
<style scoped>
   .table-hover>tbody>tr:hover {
    background-color:#dee2e6!important;
}
.font{
  font-size:15px;
}
.font_yz{
  font-size:1px;
  color:red;
}
.button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .heit{
    height:1.5rem;
  }
  .span_close:hover{
       color:#3190e8;
 }
 
.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
.jz_middle{
   vertical-align:middle;
 }
</style>


// WEBPACK FOOTER //
// src/pages/BillingInformation.vue